import React, { useEffect } from "react";
import Sidebar from "../partials/aside/Sidebar";
import TitleBar from "../partials/content/TitleBar";

export default function Welcome() {
  console.log("welcome component");
  return (
    <>
      <Sidebar activeItem="welocome" />

      <div className="content-wrapper">
        <TitleBar title="میزکار نمایش دهنده" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div>میزکار نمایش دهنده</div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
